export const getBankAccounts = payload => ({
  type: 'SEARCH_BANKS',
  // loader: true,
  payload,
});

export const setBankAccountList = data => ({
  type: 'SET_BANK_ACCOUNTS',
  data,
});

export const connectPlaid = payload => ({
  type: 'CONNECT_PLAID',
  payload,
});

export const updateBankAccount = payload => ({
  type: 'UPDATE_BANK_ACCOUNT',
  payload,
});
